import React from 'react';
import {useTranslation} from 'react-i18next';
import {promptAskPhrase} from '../../../utils/promptAskPhrase';
import {ArrowUp, FileText} from '../../icons';

const RAW = {interpolation: {escapeValue: false}};

/**
 * El nombre del ejemplo (copy.md): el primer prompt propio; sin prompts, uno armado con el primer
 * cliente; sin clientes, uno genérico. Es texto que se le dice a la IA, en español como la frase del
 * pedido, y por eso no pasa por i18n.
 */
export function exampleAskTitle(firstOwnTitle, firstClientName) {
    if (firstOwnTitle) return firstOwnTitle;
    if (firstClientName) return `Reunión semanal de ${firstClientName}`;
    return 'Resumen del mes';
}

/**
 * «Cómo funciona», en tres pasos con un ejemplo de verdad: lo escribes acá → se lo pides a tu IA por
 * el nombre → tu IA lo trae y lo corre. Es lo que una persona necesita entender UNA vez, así que se
 * oculta («Entendido, ocultar») y queda como un link en el subtítulo. Antes la explicación estaba
 * repartida entre el subtítulo, la tarjeta de la derecha y el botón de cada fila.
 *
 * El paso 2 muestra la frase real (`promptAskPhrase`), la misma que copia «Copiar frase».
 */
export function HowItWorks({exampleTitle, agencyName, onHide}) {
    const {t} = useTranslation();
    return (
        <section className="agp-how" aria-labelledby="agp-how-title">
            <div className="agp-how__head">
                <h2 id="agp-how-title" className="agp-how__title">{t('agency_prompts.how_title')}</h2>
                <button type="button" className="agp-btn -link" onClick={onHide}>
                    {t('agency_prompts.how_hide')}
                </button>
            </div>
            <ol className="agp-how__steps">
                <li className="agp-how__step">
                    <span className="agp-how__step-title">
                        <span className="agp-how__num" aria-hidden="true">1</span>
                        {t('agency_prompts.how_step1_title')}
                    </span>
                    <p className="agp-how__step-body">{t('agency_prompts.how_step1_body')}</p>
                    <div className="agp-how__sample -doc">
                        <FileText size={16} aria-hidden="true"/>
                        <span>{exampleTitle}</span>
                    </div>
                </li>
                <li className="agp-how__step">
                    <span className="agp-how__step-title">
                        <span className="agp-how__num" aria-hidden="true">2</span>
                        {t('agency_prompts.how_step2_title')}
                    </span>
                    <p className="agp-how__step-body">{t('agency_prompts.how_step2_body')}</p>
                    <div className="agp-how__sample -ask">
                        <span>{promptAskPhrase(exampleTitle)}</span>
                        <span className="agp-how__send" aria-hidden="true"><ArrowUp size={12} weight="bold"/></span>
                    </div>
                </li>
                <li className="agp-how__step">
                    <span className="agp-how__step-title">
                        <span className="agp-how__num" aria-hidden="true">3</span>
                        {t('agency_prompts.how_step3_title')}
                    </span>
                    <p className="agp-how__step-body">{t('agency_prompts.how_step3_body')}</p>
                    <div className="agp-how__sample -reply">
                        {t('agency_prompts.how_step3_sample', {title: exampleTitle, agency: agencyName, ...RAW})}
                    </div>
                </li>
            </ol>
        </section>
    );
}
